import { Button, Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './ConfirmMemberDeletionModal.module.scss';
import { Props } from './ConfirmMemberDeletionModal.types';

const ConfirmMemberDeletionModal = ({ open, onClose, onConfirm, memberName, isLoading }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={t('admin.members.deletion.confirmTitle', 'Supprimer ce membre ?')}
      size="md"
    >
      <div className={styles.content}>
        {t(
          'admin.members.deletion.confirmContent',
          '{{name}} sera retiré du bien et ne pourra plus y accéder. Cette action est irréversible (le membre devra être réinvité pour rejoindre à nouveau le bien).',
          { name: memberName }
        )}
      </div>
      <div className={styles.buttons}>
        <Button variant="outline" onClick={onClose} disabled={isLoading}>
          {t('common.cancel', 'Annuler')}
        </Button>
        <Button color="red" onClick={onConfirm} loading={isLoading}>
          {t('common.delete', 'Supprimer')}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmMemberDeletionModal;
